import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { mapGetters, mapMutations } from 'vuex'
import * as types from '@recipient/store/types'
import * as atypes from '@account/store/types'
import { invalidateUrl } from '@appbase/util'

//components
@Component({
  name: 'user-list-item',
  computed: {
    ...mapGetters({
      current: atypes.CURRENT,
      selectedUsers: types.RECIPIENT_USER_SELECT,
    }),
  },
  methods: {
    ...mapMutations({
      toggleUserSelection: types.RECIPIENT_USER_TOGGLE,
      select: types.RECIPIENT_USER_SELECT,
      unselect: types.RECIPIENT_USER_UNSELECT,
    }),
  },
})
export default class UserListItem extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: Object }) item!: recipient.OrgPerson //부서원
  @Prop({ type: Object }) dept!: recipient.Department //부서

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  loading: boolean = true
  photoUrl: string = ''

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: C O M P U T E D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  current!: account.TCurrent;

  get isSelected() {
    if (this.item?.personCode)
      return (
        this.item.personCode in this.selectedUsers
        // this.user.deptCode in this.selectedUsers
      )
    else return false
  }

  get displayName() {
    return `${this.getLangProperty(this.item, 'displayName')} ${this.getLangProperty(this.item, 'titleName')}`;    
  }

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  select!: (user: recipient.OrgPerson) => void
  unselect!: (user: recipient.OrgPerson) => void

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: A C T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  toggleUserSelection!: (user: recipient.OrgPerson) => void

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  selectedUsers!: {
    [key: string]: recipient.OrgPerson
  }

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  loadUrl(path: string) {
    this.loading = true
    const setDefault = () => {
      this.photoUrl = this.getGhostUrl()
      this.loading = false
    }
    if (path && path !== '') {
      // var url = path.split('/').pop() as string;
      // this.photoUrl = invalidateUrl('/gres/orgchart/img/user/'+url);
      // this.photoUrl = 'https://stone.feelanet.com' + path
      this.photoUrl = path
      this.loading = false
    } else {
      setDefault()
    }
  }

  getGhostUrl() {
    return invalidateUrl('/assets/bigfile/images/face-placeholder.gif')
  }

  onPhotoError(event: Event) {
    this.photoUrl = this.getGhostUrl()
    this.loading = false
    console.log('onPhotoError', this.photoUrl)
  }

  changeSelection() {
    this.toggleUserSelection(this.item)
  }

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  mounted() {
    this.loadUrl(this.item.photoPath || '')
  }
}
